module.exports = __webpack_public_path__ + "static/img/20190221021426_658728.0c573558.jpg";